import { removeCookie } from 'services/cookies';

export default function removeAuthCookies() {
  removeCookie('token');
  removeCookie('usuario');
  removeCookie('access_expires_at');
}
